/*
 * Cart page extras (sections/cart-template.liquid):
 * - "My Wishlist" strip: renders up to 4 wishlist products as cards fetched
 *   via /products/<handle>?view=wishlist-card. Heart removes from wishlist;
 *   Add to Cart adds (supplier brackets go through the supplier-fee.js
 *   chooser) and then drops the product from the wishlist.
 * - "Move to wishlist" on cart line items: saves the handle and removes the
 *   line from the cart.
 */
(function () {
  var KEY = "m-wishlist-products";
  var MAX_CARDS = 4;
  var strip = document.querySelector("[data-cart-wishlist]");

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }
  function getList() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function setList(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }
  function updateHeaderCount() {
    var n = getList().length;
    document.querySelectorAll(".m-wishlist-count").forEach(function (el) {
      el.textContent = n;
      el.classList.toggle("m:hidden", n === 0);
    });
  }
  function removeFromWishlist(handle) {
    setList(getList().filter(function (h) { return h !== handle; }));
    updateHeaderCount();
    syncToggleHearts();
  }

  function renderStrip() {
    if (!strip) return;
    var list = getList();
    var grid = strip.querySelector("[data-cart-wl-cards]");
    var countEl = strip.querySelector("[data-cart-wl-count]");
    if (!list.length || !grid) {
      strip.hidden = true;
      return;
    }
    Promise.all(
      list.slice(0, MAX_CARDS).map(function (handle) {
        return fetch(root() + "products/" + handle + "?view=wishlist-card")
          .then(function (r) { return r.ok ? r.text() : ""; })
          .catch(function () { return ""; });
      })
    ).then(function (htmls) {
      grid.innerHTML = htmls.join("");
      var cards = grid.querySelectorAll("[data-wlc]");
      if (!cards.length) {
        strip.hidden = true;
        return;
      }
      if (countEl) countEl.textContent = "(" + list.length + (list.length === 1 ? " item" : " items") + ")";
      strip.hidden = false;
    });
  }
  renderStrip();

  /* Recently viewed strip — theme stores product IDs in localStorage
     ("minimog-recently-viewed"); resolve them via the search view. */
  var recentStrip = document.querySelector("[data-cart-recent]");
  function syncToggleHearts() {
    if (!recentStrip) return;
    var list = getList();
    recentStrip.querySelectorAll("[data-wlc]").forEach(function (card) {
      var heart = card.querySelector("[data-wlc-toggle]");
      if (heart) heart.classList.toggle("is-in", list.indexOf(card.dataset.handle) !== -1);
    });
  }
  function renderRecent() {
    if (!recentStrip) return;
    var ids;
    try {
      ids = JSON.parse(localStorage.getItem("minimog-recently-viewed")) || [];
    } catch (e) {
      ids = [];
    }
    ids = ids.slice(0, MAX_CARDS);
    var grid = recentStrip.querySelector("[data-cart-recent-cards]");
    if (!ids.length || !grid) {
      recentStrip.hidden = true;
      return;
    }
    var q = ids.map(function (id) { return "id:" + id; }).join(" OR ");
    fetch(root() + "search?view=recent-cards&type=product&q=" + encodeURIComponent(q))
      .then(function (r) { return r.ok ? r.text() : ""; })
      .then(function (html) {
        var tpl = document.createElement("template");
        tpl.innerHTML = html;
        var cards = tpl.content.querySelectorAll("[data-wlc]");
        if (!cards.length) {
          recentStrip.hidden = true;
          return;
        }
        grid.innerHTML = "";
        grid.appendChild(tpl.content);
        recentStrip.hidden = false;
        syncToggleHearts();
      })
      .catch(function () {
        recentStrip.hidden = true;
      });
  }
  renderRecent();

  function refreshCartUI(res) {
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, res || {});
      var drawer = document.querySelector("m-cart-drawer");
      if (drawer && typeof drawer.onCartDrawerUpdate === "function") {
        drawer.onCartDrawerUpdate();
        if (typeof drawer.open === "function") drawer.open();
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openCartDrawer);
      }
    }
  }

  document.addEventListener("click", function (e) {
    /* heart toggle on a recently-viewed card */
    var tg = e.target.closest("[data-wlc-toggle]");
    if (tg) {
      var tgCard = tg.closest("[data-wlc]");
      if (tgCard) {
        var handle = tgCard.dataset.handle;
        var list = getList();
        if (list.indexOf(handle) === -1) list.unshift(handle);
        else list = list.filter(function (h) { return h !== handle; });
        setList(list);
        updateHeaderCount();
        syncToggleHearts();
        renderStrip();
      }
      return;
    }

    /* heart on a wishlist card: remove from wishlist */
    var rm = e.target.closest("[data-wlc-remove]");
    if (rm) {
      var rmCard = rm.closest("[data-wlc]");
      if (rmCard) {
        removeFromWishlist(rmCard.dataset.handle);
        rmCard.remove();
      }
      renderStrip();
      return;
    }

    /* direct add from a wishlist card */
    var add = e.target.closest("[data-wlc-add]");
    if (add && !add.classList.contains("is-loading")) {
      var card = add.closest("[data-wlc]");
      add.classList.add("is-loading");
      fetch(root() + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ items: [{ id: parseInt(add.dataset.variantId, 10), quantity: 1 }] }),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) throw new Error(res.description || res.message || "add failed");
          if (card && !card.closest("[data-cart-recent]")) {
            removeFromWishlist(card.dataset.handle);
            card.remove();
            renderStrip();
          }
          refreshCartUI(res);
        })
        .catch(function (err) {
          console.error("[cart-extras]", err);
        })
        .finally(function () {
          add.classList.remove("is-loading");
        });
      return;
    }

    /* move a cart line item to the wishlist */
    var mv = e.target.closest("[data-move-to-wishlist]");
    if (mv) {
      e.preventDefault();
      var handle = mv.dataset.handle;
      var list = getList();
      if (list.indexOf(handle) === -1) {
        list.unshift(handle);
        setList(list);
      }
      updateHeaderCount();
      var mcart = document.querySelector("m-cart");
      if (mcart && typeof mcart.updateQuantity === "function") {
        mcart.updateQuantity(mv.dataset.index, 0);
      }
      setTimeout(renderStrip, 600);
    }
  });

  /* Mobile cart page: the subtotal/checkout card is pinned on top
     (cart-page.css); keep it compact by moving the addons, gift-wrapping,
     trust-badge and GOVX blocks below the item list. Restored into the
     card in their original spots on desktop. */
  var cartMql = window.matchMedia("(max-width: 1023px)");
  function belowContainer() {
    var left = document.querySelector(".m-cartx__left");
    if (!left) return null;
    var el = left.querySelector(".m-cartx__below");
    if (!el) {
      el = document.createElement("div");
      el.className = "m-cartx__below";
      var body = left.querySelector(".m-cart__body");
      if (body && body.nextSibling) left.insertBefore(el, body.nextSibling);
      else left.appendChild(el);
    }
    return el;
  }
  function cartMobileLayout() {
    var card = document.querySelector(".m-cartx__card");
    var right = document.querySelector(".m-cartx__right");
    if (!card || !right) return;
    var addons = document.querySelector("m-cart-addons.m-cart-addon");
    var gift = document.querySelector("[data-minimog-gift-wrapping]");
    var trust = document.querySelector(".m-cart__trust-badge");
    var govx = document.querySelector(".m-cartx__govx");
    if (cartMql.matches) {
      var below = belowContainer();
      if (!below) return;
      [addons, gift, govx, trust].forEach(function (el) {
        if (el) below.appendChild(el);
      });
    } else {
      var checkout = card.querySelector(".m-cart__checkout");
      if (addons && checkout) card.insertBefore(addons, checkout);
      if (gift && checkout) card.insertBefore(gift, checkout);
      if (trust) card.appendChild(trust);
      if (govx) right.appendChild(govx);
      var below = document.querySelector(".m-cartx__below");
      if (below && !below.children.length) below.remove();
    }
  }
  cartMobileLayout();
  if (cartMql.addEventListener) cartMql.addEventListener("change", cartMobileLayout);

  /* GOVX app injects its verify block at the end of the cart form with its
     own float styling — relocate it under the summary card in the right
     column (or below the items on mobile) so it reads as part of the layout. */
  var govxObserver = null;
  function placeGovx() {
    var govx = document.querySelector(".govx-id-full-wrapper");
    var right = document.querySelector(".m-cartx__right");
    if (!govx || !right) return false;
    var wrap = document.querySelector(".m-cartx__govx");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "m-cartx__govx";
      var target = cartMql.matches ? belowContainer() || right : right;
      target.appendChild(wrap);
    }
    if (wrap.contains(govx)) return true;
    wrap.appendChild(govx);
    return true;
  }
  if (!placeGovx()) {
    govxObserver = new MutationObserver(function () {
      if (placeGovx() && govxObserver) {
        govxObserver.disconnect();
        govxObserver = null;
      }
    });
    govxObserver.observe(document.body, { childList: true, subtree: true });
  }

  /* supplier bracket added through the chooser from a wishlist card */
  document.addEventListener("supplier-fee:added", function (e) {
    if (!strip) return;
    var vid = e.detail && e.detail.variantId;
    if (!vid) return;
    var matched = false;
    strip.querySelectorAll("[data-wlc]").forEach(function (card) {
      var btn = card.querySelector("[data-supplier-atc]");
      if (btn && parseInt(btn.dataset.variantId, 10) === vid) {
        removeFromWishlist(card.dataset.handle);
        card.remove();
        matched = true;
      }
    });
    if (matched) renderStrip();
  });
})();
